import React from 'react';

const OfficeMap = ({ language }) => {
  const content = {
    en: {
      title: 'Find Us',
      subtitle: 'Visit our office in Deqing County, China'
    },
    zh: {
      title: '找到我们',
      subtitle: '访问我们在中国德清县的办公室'
    }
  };

  const t = content?.[language];

  // Deqing County coordinates
  const lat = 30.5449;
  const lng = 119.9766;

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-2xl font-heading font-semibold text-foreground mb-1">
          {t?.title}
        </h2>
        <p className="text-muted-foreground">
          {t?.subtitle}
        </p>
      </div>
      <div className="w-full h-[400px] lg:h-[500px]">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="WGIH Africoffee Office Location"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
          className="border-0"
        />
      </div>
    </div>
  );
};

export default OfficeMap;